import { Card, Row, Col } from "react-bootstrap";

interface ExportColumn {
    key: string;
    title: string;
    description: string;
    icon: string;
    iconColor: string;
    iconBackground: string;
}

const initialColumns: ExportColumn[] = [
    {
        key: "code",
        title: "Código de distribuidor",
        description: "Código único del distribuidor.",
        icon: "ri-hashtag",
        iconColor: "#8BE45D",
        iconBackground: "rgba(139,228,93,.12)"
    },
    {
        key: "status",
        title: "Estado",
        description: "Estado actual del distribuidor (Activo / Inactivo).",
        icon: "ri-user-fill",
        iconColor: "#3B82F6",
        iconBackground: "rgba(59,130,246,.12)"
    },
    {
        key: "royalties",
        title: "Puntos de regalías",
        description: "Puntos acumulados por regalías.",
        icon: "ri-money-dollar-circle-fill",
        iconColor: "#FBBF24",
        iconBackground: "rgba(251,191,36,.12)"
    },
    {
        key: "bonus",
        title: "Puntos de bonificaciones",
        description: "Puntos acumulados por bonificaciones.",
        icon: "ri-gift-fill",
        iconColor: "#8B5CF6",
        iconBackground: "rgba(139,92,246,.12)"
    },
    {
        key: "rank",
        title: "Rango actual",
        description: "Último rango alcanzado por el distribuidor.",
        icon: "ri-star-fill",
        iconColor: "#FBBF24",
        iconBackground: "rgba(251,191,36,.12)"
    },
    {
        key: "registered",
        title: "Usuarios registrados",
        description: "Total de usuarios registrados en su red.",
        icon: "ri-team-fill",
        iconColor: "#22D3EE",
        iconBackground: "rgba(34,211,238,.12)"
    },
    {
        key: "active",
        title: "Usuarios activos",
        description: "Total de usuarios activos en su red.",
        icon: "ri-user-shared-fill",
        iconColor: "#84CC16",
        iconBackground: "rgba(132,204,22,.12)"
    }
];

interface Props {
    selectedColumns: string[];
    setSelectedColumns: (value: string[]) => void;
}

const ExportColumns = ({ selectedColumns, setSelectedColumns }: Props) => {

    const toggleColumn = (key: string) => {
        if (selectedColumns.includes(key)) {
            setSelectedColumns(selectedColumns.filter((x) => x !== key));
        } else {
            setSelectedColumns([...selectedColumns, key]);
        }
    };

    return (
        <Card
            className="border-0 rounded-4 p-4"
            style={{
                background: "#0d1117",
                color: "#fff"
            }}
        >
            <h5 className="fw-bold mb-2">
                2. Columnas que se exportarán
            </h5>

            <div
                className="mb-4"
                style={{
                    color: "#9ca3af",
                    fontSize: 14
                }}
            >
                Selecciona la información que deseas incluir en el archivo Excel.
            </div>

            <Row className="g-3">
                {initialColumns.map((column) => {
                    const checked = selectedColumns.includes(column.key);

                    return (
                        <Col xl key={column.key}>
                            <div
                                className="position-relative rounded-4 p-3 text-center h-100"
                                onClick={() => toggleColumn(column.key)}
                                style={{
                                    cursor: "pointer",
                                    border: "1px solid rgba(255,255,255,.08)",
                                    minHeight: 175
                                }}
                            >
                                <div
                                    className="position-absolute d-flex align-items-center justify-content-center"
                                    style={{
                                        top: 10,
                                        right: 10,
                                        width: 18,
                                        height: 18,
                                        borderRadius: 4,
                                        background: checked ? "#43D131" : "transparent",
                                        border: checked
                                            ? "1px solid #43D131"
                                            : "1px solid rgba(255,255,255,.15)"
                                    }}
                                >
                                    {checked && (
                                        <i className="ri-check-line" style={{ color: "#fff", fontSize: 12 }} />
                                    )}
                                </div>

                                <div
                                    className="mx-auto rounded-circle d-flex align-items-center justify-content-center mb-3 mt-2"
                                    style={{
                                        width: 50,
                                        height: 50,
                                        background: column.iconBackground
                                    }}
                                >
                                    <i
                                        className={column.icon}
                                        style={{
                                            fontSize: 25,
                                            color: column.iconColor
                                        }}
                                    />
                                </div>

                                <div className="fw-bold mb-2" style={{ fontSize: 14 }}>
                                    {column.title}
                                </div>

                                <div style={{ color: "#9ca3af", fontSize: 12 }}>
                                    {column.description}
                                </div>
                            </div>
                        </Col>
                    );
                })}
            </Row>

            <div
                className="rounded-4 p-4 mt-4 d-flex align-items-center justify-content-center"
                style={{
                    border: "1px solid rgba(255,255,255,.08)",
                    minHeight: "90px"
                }}
            >
                <div className="d-flex align-items-center">
                    <i
                        className="ri-file-list-3-line"
                        style={{
                            fontSize: 30,
                            color: "#fff",
                            marginRight: 20
                        }}
                    />

                    <div>
                        <div className="fw-semibold mb-1" style={{ color: "#43D131" }}>
                            Información a exportar
                        </div>

                        <div style={{ color: "#9ca3af", fontSize: 13 }}>
                            Se exportarán todas las columnas seleccionadas con los filtros aplicados.
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ExportColumns;